import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { withAuth, AuthState } from 'context/auth';

const StylesCss = createGlobalStyle<{ customCss: string }>`
  ${props => props.customCss}
`;

interface Props {
  auth: AuthState;
  sandbox: Sandbox | undefined;
}

const Styles = (props: Props) => {
  const { custom_css: customCss = '' } =
    props.auth.sandbox?.themeInformation || {};

  return <StylesCss customCss={customCss} />;
};

const CustomStyles = withAuth(Styles);

export default CustomStyles;
